import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BaseComponent, FrontendDisplayHtmlType, TranslatedToastrService, ValidationHandlerService } from 'lib/Vestra.shared';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { AuthenticationService, ForgotPasswordModel } from 'src/app/services/api-services';
import { Location } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Component({
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent extends BaseComponent implements OnInit {
    forgotPasswordForm: FormGroup;
    public type: FrontendDisplayHtmlType = FrontendDisplayHtmlType.ForgotPasswordInfo;

    constructor(private location: Location, private authenticationService: AuthenticationService, private translatedToastrService: TranslatedToastrService, protected override validationHandlerService: ValidationHandlerService, protected override modalService: BsModalService, protected override spinnerService: NgxSpinnerService, private router: Router) {
        super(spinnerService, modalService, validationHandlerService);
    }

    public ngOnInit(): void {
        this.forgotPasswordForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email]),
        });
    }

    public forgotPassword = async (): Promise<any> => {
        if (this.validationHandlerService.checkFormValid(this.forgotPasswordForm)) {
            const forgotPass = this.forgotPasswordForm.getRawValue();
            const forgotPassModel: ForgotPasswordModel = {
                email: forgotPass.email,
                clientUri: 'authentication/resetpassword',
            };

            return this.handleSpinner(
                firstValueFrom(this.authenticationService.forgotPassword(forgotPassModel))
                    .then(res => {
                        this.forgotPasswordForm.reset();
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err, this.forgotPasswordForm);
                    })
            );
        }
    };
}
